module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Cacahuate_Crudo_Redskins.26ed26fd.pdf";